// @vocab-ignore

export const Tools = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.946 91.7128L60.8509 48.6171C61.6112 46.4968 62.0524 44.222 62.1026 41.8455C62.3516 30.0315 52.9821 20.2535 41.1679 20.0045C38.9595 19.9599 36.8278 20.247 34.8109 20.8279L44.5122 30.9505C46.1209 32.6291 46.0635 35.3162 44.3846 36.9246L35.6472 45.2984C33.9684 46.9068 31.2816 46.8494 29.6732 45.1708V45.1643L20.2205 35.3098C19.6909 37.1033 19.3653 38.9797 19.3271 40.9392C19.0781 52.7532 28.4476 62.5312 40.2618 62.78C42.9826 62.8374 45.5934 62.379 48.0068 61.5035L91.0347 104.625C94.6279 108.218 100.353 108.218 103.946 104.625C107.54 101.031 107.54 95.3062 103.946 91.7128ZM97.2511 101.715C95.011 101.715 93.2686 99.8509 93.2686 97.7319C93.2686 95.6189 95.1321 93.7489 97.2511 93.7489C99.3639 93.7489 101.234 95.6126 101.234 97.7319C101.234 99.8509 99.4918 101.715 97.2511 101.715Z"
      fill="#EE399E"
    />
    <path
      d="M104.241 23.7706L95.3629 28.2129L93.4835 33.8456L63.0254 64.3039L68.1478 69.4262L98.6095 38.9645L104.241 37.0911L108.677 28.2129L104.241 23.7706Z"
      fill="#B6C7E0"
    />
    <path
      d="M60.1778 61.4568L56.5832 65.0514L54.7809 63.2493L25.942 92.0879C23.9516 94.0782 23.9516 97.3094 25.942 99.2996L33.1495 106.507C35.1396 108.498 38.3711 108.498 40.3615 106.507L69.2 77.6685L67.3963 75.8649L70.9913 72.2702L68.1474 69.4262L63.0249 64.3039L60.1778 61.4568Z"
      fill="#0D3880"
    />
    <path
      d="M37.9535 101.31C37.593 101.31 37.2325 101.172 36.9575 100.897C36.4074 100.347 36.4074 99.4553 36.9575 98.9051L58.658 77.2046C59.2081 76.6544 60.0999 76.6544 60.65 77.2046C61.2001 77.7548 61.2001 78.6462 60.65 79.1964L38.9495 100.897C38.6745 101.172 38.314 101.31 37.9535 101.31Z"
      fill="#7795C2"
    />
    <path
      d="M32.5472 95.9037C32.1868 95.9037 31.8263 95.7661 31.5513 95.491C31.0011 94.9408 31.0011 94.0494 31.5513 93.4992L53.2518 71.7987C53.8018 71.2485 54.6937 71.2485 55.2437 71.7987C55.7939 72.3489 55.7939 73.2403 55.2437 73.7905L33.5432 95.491C33.2682 95.7661 32.9077 95.9037 32.5472 95.9037Z"
      fill="#7795C2"
    />
  </svg>
);
